export enum CatalogFilterEnum {
    CATEGORY = 'category',
    ORDERING = 'ordering',
    SEARCH = 'search',
}
